import { GqlQuery } from './GqlQuery';

export * from './client';
export * from './type';

export const gqlQuery = new GqlQuery();
